import React from "react";
import { eraseCookie, getCookie } from "../utils/cookie";
import { broadcast, useChannel } from "./useChannel";
import { go } from "../route/Route";

const cookieName = "authToken";
const sessionChannelName = "session";

export interface AuthToken {
	id: string,
	account: string,
	name: string,
	roles: string[],
	t: string,
	hash: string,
	impersonating: boolean,
}

function loadFromCookie() {
    const data = getCookie(cookieName);
    lastTokenData = data ? data : "";

    var obj = {} as AuthToken;
	if (!data) return obj;

	const items = data?.split("&");
	for(let item of items) {
		const parts = item.split("=");

		const name = parts[0];
		let val: any =  decodeURIComponent(parts[1]);

		if (name === "roles") val = val.split("|");
		if (name === "i" && val === "1") {
			obj.impersonating = true;
			continue;
		}

		(obj as any)[name] = val;
	}

    return obj;
}

export let token: AuthToken | undefined = undefined;
let lastTokenData: string = "";

export function initAuthToken() {
	token = loadFromCookie();	
}

export function loginSuccess() {
	initAuthToken();
	broadcast(sessionChannelName);
}

export function useSession() {

	const [authToken, setAuthToken] = React.useState(token);

	useChannel(sessionChannelName, React.useCallback(() => {
		setAuthToken(token);
	}, []));

	return {
		authToken,
		isAuthenticated: isAuthenticated,
    };

}

export function isAuthenticated(): boolean {
    return (
        token !== undefined
        && token.hash !== undefined
        && token.id !== undefined
        && token.account !== undefined
        && token.roles !== undefined
        && token.name !== undefined
	);
};

export function logoff() {
	eraseCookie(cookieName);
	token = {} as AuthToken;
	localStorage.clear();
    
	broadcast(sessionChannelName);

	if (window.location.host === "techsync.app") {
		go("/techsync/");
	} else {
		go("/");
	}
}

export function hasRole(name: string) {
	if (token && token.roles) {
		return (token.roles.indexOf(name) >= 0);
	}
	return false;
}

export function isImpersonating() {
	return (token && token.impersonating);
}